/**
 * Picking the two colours a character is their own.
 *
 * A row of tones that suit the world, and a picker for anybody who wants
 * something else. Kept small on purpose: the body is one colour and the eyes are
 * another, and a character screen that asks twelve questions is a character
 * screen people leave.
 */

const SKINS = [
  '#f0d3b8',
  '#e0b48c',
  '#c68b5e',
  '#a56a41',
  '#7a4c2e',
  '#5a3620',
  '#3a2317',
  '#8fae7a',
  '#7fa2b8',
  '#b08fc0',
];

const EYES = ['#f2efe6', '#d8c17a', '#7fb4d8', '#79c08a', '#c47a7a', '#9a86c8', '#2b2b2b'];

function Swatches({
  colours,
  chosen,
  onPick,
}: {
  colours: readonly string[];
  chosen: string;
  onPick: (colour: string) => void;
}): JSX.Element {
  return (
    <div className="swatches">
      {colours.map((colour) => (
        <button
          key={colour}
          type="button"
          className={colour.toLowerCase() === chosen.toLowerCase() ? 'swatch on' : 'swatch'}
          style={{ background: colour }}
          title={colour}
          aria-label={colour}
          onClick={() => onPick(colour)}
        />
      ))}
      <input
        type="color"
        className="swatch-any"
        value={chosen}
        title="Any colour"
        onChange={(event) => onPick(event.target.value)}
      />
    </div>
  );
}

export function ColourChoice({
  skin,
  eyes,
  onChange,
}: {
  skin: string;
  eyes: string;
  /**
   * One colour at a time.
   *
   * Told which of the two changed rather than handed both, so whoever is holding
   * the state merges it against what they have now. Handing back a pair made of
   * one fresh colour and one read at render is how a second choice undoes the
   * first.
   */
  onChange: (which: 'skin' | 'eyes', colour: string) => void;
}): JSX.Element {
  return (
    <div className="colour-choice">
      <label className="colour-row">
        <span>Skin</span>
        <Swatches colours={SKINS} chosen={skin} onPick={(colour) => onChange('skin', colour)} />
      </label>

      <label className="colour-row">
        <span>Eyes and brows</span>
        <Swatches colours={EYES} chosen={eyes} onPick={(colour) => onChange('eyes', colour)} />
      </label>
    </div>
  );
}
